/** vendor */
import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

/** lib */
import TimerInput from '../UI/TimerInput'

const initialStep = { 
  id: null, 
  title: '', 
  description: '', 
  timer: '',
  step_image: null 
}

const CreateStepDialog = ({ 
  showDialog = false, 
  step, 
  onUpdate = () => {}, 
  onCancel = () => {} 
}) => {
  const [tab, setTab] = useState('required')
  const [isOpen, setIsOpen] = useState(true)
  const [currentStep, setCurrentStep] = useState(initialStep) 

  const handleToggleTab = (e) => {
    e.preventDefault()
    setTab(e.target.href.split('#')[1])
  }

  const handleChange = (e) => {
    const currentStepCopy = JSON.parse(JSON.stringify(currentStep))
    currentStepCopy[e.target.id] = e.target.value
    setCurrentStep(currentStepCopy)
  }

  const setStepId = () => {
    const currentStepCopy = JSON.parse(JSON.stringify(currentStep))
    currentStepCopy.id = uuidv4()
    setCurrentStep(currentStepCopy)
  }

  /**
   * Hooks
   */
  useEffect(() => {    
    setIsOpen(showDialog)
    if(showDialog && !currentStep?.id) { 
      setStepId()
    } 
    if (showDialog && step) {
      setCurrentStep(step)
    }
  }, [showDialog, step])

  /**
   * Handlers
   */
  const handleCancel = () => {
    setCurrentStep(initialStep)
    setIsOpen(false)
    onCancel()
  }

  const handleOnTimerChange = (newValue) => {
    const currentStepCopy = JSON.parse(JSON.stringify(currentStep))
    currentStepCopy['timer'] = newValue
    setCurrentStep(currentStepCopy)
  }

  const handleConfirm = () => {
    onUpdate(currentStep)
    setCurrentStep(initialStep)
    setIsOpen(false)
  }

  return (
    <div
      className={`fixed z-50 inset-0 overflow-y-auto ${
        isOpen ? 'flex' : 'hidden'
      } items-center justify-center`}
    >
      <div className="fixed inset-0 bottom-0 bg-an_green-dark opacity-60"></div>

      <div className="fixed bottom-0 w-screen z-50"> 
        <div className="w-full px-2 md:max-w-xl mx-auto">
          <div className="bg-an_white rounded-md shadow-md z-50">
            <h2 className="w-full text-xl text-an_white text-center items-center p-4 bg-an_green-dark rounded-t">
              {currentStep?.stepId ? 'edit step' : 'create step'}
            </h2>

            <ul className="mt-2 flex justify-center text-sm font-medium text-center border-b-2 border-an_orange-dark overflow-hidden px-2">
              <li className="w-1/3 text-center">
                  <a 
                    href="#required" 
                    aria-current="page"
                    onClick={handleToggleTab}
                    className={`${tab === 'required' ? 'text-an_white bg-an_orange-dark active' : 'text-an_orange-dark '} inline-block w-full p-2 rounded-t-lg`}
                  >
                      required
                  </a>
              </li>
              <li className="w-1/3 text-center">
                  <a 
                    href="#additional"
                    onClick={handleToggleTab} 
                    className={`${tab === 'additional' ? 'text-an_white bg-an_orange-dark active' : 'text-an_orange-dark '} inline-block w-full p-2 rounded-t-lg`}
                  >
                    additional
                  </a>
              </li>
            </ul>

            <div className="flex min-w-full justify-center"> 
                <div className="w-full p-2 bg-an_white-dark">
                  { 
                    tab === 'required' && 
                      <>
                        <div className="mb-4 w-full">
                            <label htmlFor="name" className="block mb-2 text-sm font-medium text-an_green-dark">name</label>
                            <div className="relative">
                                <input 
                                    type="text" 
                                    id="title"
                                    value={currentStep?.title}
                                    onChange={handleChange} 
                                    className="border border-an_green-dark text-an_green-dark text-sm rounded block w-full pr-10 p-2.5" 
                                    placeholder="Step Name"
                                />
                            </div>
                        </div>

                        <div className="mb-4 w-full">
                            <label htmlFor="description" className="block mb-2 text-sm font-medium text-an_green-dark">Description</label>
                            <textarea 
                                id="description" 
                                rows="4"
                                onChange={handleChange}
                                value={currentStep?.description} 
                                className="block p-2.5 w-full text-sm text-an_green-dark rounded border border-an_green-dark" 
                                placeholder="Step Description"></textarea>
                        </div>
                      </>  
                  }

                  { 
                    tab === 'additional' && 
                      <>
                        <div className="mb-4 items-center">
                          <div className="w-40 mx-auto h-36 border border-an_green-dark rounded-sm mt-1 flex-grow">

                          </div>
                          <div className="pt-2 border-t mt-1">
                            <label className="block mb-2 text-xs font-medium text-an_green-dark" htmlFor="user_avatar">Upload file</label>
                            <input 
                                className="block w-full overflow-hidden text-xs text-an_green-dark rounded-lg border border-an_green-dark cursor-pointer" 
                                aria-describedby="step_image_help" 
                                id="step_image" 
                                type="file"
                                value={step?.step_image}  
                                onChange={handleChange}
                            />
                            <div 
                                className="mt-1 text-xs text-an_green-dark" 
                                id="step_image_help"
                            >
                                (Optional) a picture of the step
                            </div>
                          </div>
                        </div>

                        <div className="w-full pt-1 border-t mt-1">
                          <label htmlFor="description" className="block mb-2 text-sm font-medium text-an_green-dark">Timer</label>
                          <TimerInput onUpdate={handleOnTimerChange} />
                        </div>
                      </>
                  }
                </div>
            </div>
          </div>

          <div className="flex justify-center w-full py-3 md:max-w-xl mx-auto">
              <button
                className="px-5 py-2 rounded w-36 text-an_green-dark bg-an_white mr-1"
                onClick={handleCancel}
              >
                cancel
              </button>

              <button
                className={`px-5 ml-1 py-2 relative rounded w-36 border border-an_orange-darker3 text-an_white bg-an_orange text-border-orange`}
                onClick={handleConfirm}
              >
                <span>create</span> 
              </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateStepDialog
